export let Device = {
	size: 'mobile',
	touch: false,
	browser: null
};
